import { render, staticRenderFns } from "./TabelaLoteDeProducao.vue?vue&type=template&id=44e9a622&lang=pug"
import script from "./TabelaLoteDeProducao.vue?vue&type=script&lang=js"
export * from "./TabelaLoteDeProducao.vue?vue&type=script&lang=js"
import style0 from "./TabelaLoteDeProducao.vue?vue&type=style&index=0&id=44e9a622&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports